import { render, staticRenderFns } from "./ActivationTasksSummaryRouterView.vue?vue&type=template&id=05351484&"
import script from "./ActivationTasksSummaryRouterView.vue?vue&type=script&lang=js&"
export * from "./ActivationTasksSummaryRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports